import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Routes from "./routes";
import VueCarousel from 'vue-carousel';
import VueCookies from 'vue-cookies';
import LazyLoadDirective from "./directives/LazyLoadDirective";
import 'jquery'
import '@fortawesome/fontawesome-free'


window.$ = window.jQuery = require('jquery');

Vue.use(VueRouter);
Vue.use(VueCarousel);
Vue.use(VueCookies);

Vue.directive("lazyload", LazyLoadDirective);

const router = new VueRouter({
  // mode:'history',
  routes: Routes
});

new Vue({
  // el: '#App',
  render: h => h(App),
  router:router
}).$mount('#App');




